import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const RowRemove = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function RowRemove({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.5 4C2.5 3.44772 2.94772 3 3.5 3H20.5C21.0523 3 21.5 3.44772 21.5 4V6C21.5 6.55228 21.0523 7 20.5 7H3.5C2.94771 7 2.5 6.55228 2.5 6V4ZM4 5.5V4.5H20V5.5H4Z'
        fill={color}
      />
      <path
        d='M3 18.25C2.72386 18.25 2.5 18.4739 2.5 18.75V19.25C2.5 19.5261 2.72386 19.75 3 19.75H8C8.27614 19.75 8.5 19.5261 8.5 19.25V18.75C8.5 18.4739 8.27614 18.25 8 18.25H3Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.5 10C2.94772 10 2.5 10.4477 2.5 11V13C2.5 13.5523 2.94771 14 3.5 14H20.5C21.0523 14 21.5 13.5523 21.5 13V11C21.5 10.4477 21.0523 10 20.5 10H3.5ZM4 11.5V12.5H20V11.5H4Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 18C10 17.4477 10.4477 17 11 17H20.5C21.0523 17 21.5 17.4477 21.5 18V20C21.5 20.5523 21.0523 21 20.5 21H11C10.4477 21 10 20.5523 10 20V18ZM11.5 19.5V18.5H20V19.5H11.5Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'row-remove-icon-svg'} iconRender={iconRender} {...props} />;
});

export default RowRemove;
